module.exports = __webpack_public_path__ + "img/stock2.59a6dcb7.png";